import { Injectable } from '@angular/core';
import { CryptoService } from 'src/app/shared/services/crypto.service';
const PERMISSION_KEY = 'auth-permissions';

@Injectable({
  providedIn: 'root'
})
export class PermissionStorageService {

  constructor(
    private cryptoService : CryptoService
  ) { }

  getPermissions(): string[] | null{
      return this.cryptoService.aesDecrypt(window.sessionStorage.getItem(PERMISSION_KEY) ?? '');
  }

  savePermissions(permissions : string[]){
    window.sessionStorage.removeItem(PERMISSION_KEY);
    window.sessionStorage.setItem(PERMISSION_KEY, this.cryptoService.aesEncrypt(permissions));
  }
}
